import { Component, inject, input } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { RouterLink } from '@angular/router';

import { environment } from '../../../environments/environment';

import { MedicStore } from '../../shared/state/medic.store';
import { UiStore } from '../../shared/state/ui.store';
import { MatToolbar } from '@angular/material/toolbar';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NavMedicComponent } from './nav-medic/nav-medic.component';
import { NavNotificariComponent } from './nav-notificari/nav-notificari.component';
import { NavUserComponent } from './nav-user/nav-user.component';
import { JudetPipe } from '../../shared/pipes/judet.pipe';

@Component({
    selector: 'app-nav-header',
    templateUrl: './nav-header.component.html',
    styleUrls: ['./nav-header.component.scss'],
    host: { role: 'banner' },
    imports: [MatToolbar, MatIconButton, MatIcon, MatButton, RouterLink, NavMedicComponent, NavNotificariComponent, NavUserComponent, JudetPipe]
})
export class NavHeaderComponent {
  private readonly uiStore = inject(UiStore);

  readonly sidenav = input.required<MatSidenav>();

  prod = environment.production;

  protected readonly medic = inject(MedicStore).medicData;
  protected readonly isMedicSelected = this.uiStore.isMedicSelected;
  protected readonly currentUser = this.uiStore.user;
}
